import { SlideList } from './List.jsx';
import { SlideEdit } from './Edit.jsx';
import { SlideCreate } from './Create.jsx';
import SlideshowIcon from '@mui/icons-material/Slideshow';

export default {
  list: SlideList,
  edit: SlideEdit,
  create: SlideCreate,
  icon: SlideshowIcon,
  options: { label: 'Hero slides' },
};
